

/**
 * @description The function to create a new account and signup for Ink Finder
 * @param {object} Auth The service called to authenticate
 * @param {unknown} $state Service from ui-router
 * @param {unknown} AlertMessages Alerts service
 * @param {unknown} $cookies Angular cookies service
 */
function SignupController(
  Auth,
  $state,
  AlertMessages,
  $cookies
) {
  let vm = this;
  vm.$onInit = function() {
    vm.signup = signup;
    vm.authenticate = authenticate;
    vm.required = false;
  };

/**
 * @description Signup with Ink Finder username and password
 * @param {object} credentials The user object containing an email and password
 * @param {object} $state Unknown
 * TODO $stateParams.as; $stateParams or $state.params doesn't load in this
 * controller for some readon.
 */
  function signup(credentials) {
    $cookies.remove('inkfinder');
    Auth.signupInkFinder(credentials).then(function() {
      $state.go('signup.collector');
    })
    .catch(function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

/**
  * @description Via Social API
  * @param {unknown} provider Unknown
  */
  function authenticate(provider) {
    $cookies.remove('inkfinder');
    Auth.loginSocial(provider)
    .then(function() {
      let next = 'signup.' + $state.params.as;
      $state.go(next);
    })
    .catch(function(error) {
      AlertMessages.add({
        msg: error, // Errors from Satellizer
        type: 'danger'
      });
    });
  }
}

angular
  .module('inkfinder')
  .controller('SignupController', SignupController);



// WEBPACK FOOTER //
// ./components/signup/signup.controller.js